import { Checkbox, CheckboxSize } from "shared/components";
import { Avatar } from "shared/components/Avatar";
import { NOOP } from "./constants";

interface AssigneeUserRowProps {
  userId: number;
  name: string;
  isSelected: boolean;
  isCurrentUser: boolean;
  onToggle: (userId: number) => void;
}

export const AssigneeUserRow = ({
  userId,
  name,
  isSelected,
  isCurrentUser,
  onToggle
}: AssigneeUserRowProps) => (
  <div
    className="flex w-full items-center justify-start gap-3 px-4 py-2.5 hover:bg-alpha-40 cursor-pointer"
    onClick={() => onToggle(userId)}
  >
    <Checkbox
      checked={isSelected}
      size={CheckboxSize.SM}
      wrapperClassName="!w-auto !flex-none !p-0 justify-center"
      onChange={NOOP}
    />
    <Avatar name={name} className="text-[9px] text-content-1000" size={22} />
    <p className="text-base font-medium text-content-1000">
      {name}
      {isCurrentUser && <span className="text-content-200">&nbsp;(You)</span>}
    </p>
  </div>
);
